var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIdea(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 43,
    viewBox: "0 0 49 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.978 16.1191H39.6668H17.4527C15.3894 16.1191 13.7168 17.6502 13.7168 19.5389V27.3047V35.0988C13.7168 36.9876 15.3895 38.5186 17.4527 38.5186H41.1459C42.0108 38.5186 42.8489 38.7933 43.5173 39.2958L46.1871 41.3033C46.7967 41.7616 47.7139 41.3647 47.7139 40.6427V19.539C47.7139 17.6502 46.0413 16.1191 43.978 16.1191Z",
    fill: "#D2DCFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8534 16.1191V20.6498C39.8534 24.4133 36.5084 27.4751 32.396 27.4751H13.7168V19.5386C13.7168 17.6501 15.3902 16.1191 17.4534 16.1191H39.8534Z",
    fill: "#93B2F4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.68515 1.50098H32.2104C34.2738 1.50098 35.9464 3.03208 35.9464 4.92072V20.4808C35.9464 22.3695 34.2737 23.9005 32.2104 23.9005H8.51722C7.65232 23.9005 6.81422 24.1752 6.14588 24.6777L3.47604 26.6852C2.86657 27.1435 1.94922 26.7466 1.94922 26.0246V4.92081C1.94922 3.03208 3.62189 1.50098 5.68515 1.50098Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9722 10.2658C24.9722 7.22029 22.2751 4.75146 18.948 4.75146C15.6209 4.75146 12.9238 7.22038 12.9238 10.2658C12.9238 12.5534 14.4457 14.5154 16.6131 15.3504V16.8916L17.0695 18.0064H20.748L21.283 16.8916V15.3504C23.4504 14.5154 24.9722 12.5534 24.9722 10.2658Z",
    fill: "#FDCB50"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2822 16.8896H16.6123V19.7965C16.6123 20.2686 17.0304 20.6514 17.5463 20.6514H20.3482C20.864 20.6514 21.2822 20.2687 21.2822 19.7965V16.8896Z",
    fill: "#93B2F4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.6854 12.7007C8.6854 20.1079 11.1356 23.9 11.1356 23.9H8.51731C7.65223 23.9 6.81413 24.175 6.14625 24.6774L3.47567 26.6852C2.86639 27.1432 1.94922 26.7465 1.94922 26.0244V4.92083C1.94922 3.03228 3.62171 1.50049 5.68487 1.50049H11.1356C11.1356 1.50049 8.6854 5.29343 8.6854 12.7007Z",
    fill: "#D2DCFD"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7168 23.8991V35.0988C13.7168 36.9876 15.3895 38.5186 17.4527 38.5186H41.146C42.0108 38.5186 42.8489 38.7933 43.5173 39.2958L46.1871 41.3033C46.7967 41.7616 47.7139 41.3647 47.7139 40.6427V19.5389C47.7139 17.6502 46.0413 16.1191 43.978 16.1191H35.9457",
    stroke: "#052A75",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5.68515 1.50098H32.2104C34.2738 1.50098 35.9464 3.03208 35.9464 4.92072V20.4808C35.9464 22.3695 34.2737 23.9005 32.2104 23.9005H8.51722C7.65232 23.9005 6.81422 24.1752 6.14588 24.6777L3.47604 26.6852C2.86657 27.1435 1.94922 26.7466 1.94922 26.0246V4.92081C1.94922 3.03208 3.62189 1.50098 5.68515 1.50098Z",
    stroke: "#052A75",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9722 10.2658C24.9722 7.22029 22.2751 4.75146 18.948 4.75146C15.6209 4.75146 12.9238 7.22038 12.9238 10.2658C12.9238 12.5534 14.4457 14.5154 16.6131 15.3504V16.8916H21.283V15.3504C23.4504 14.5154 24.9722 12.5534 24.9722 10.2658Z",
    stroke: "#052A75",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2832 16.8896H16.6133V19.7965C16.6133 20.2686 17.0314 20.6514 17.5473 20.6514H20.3492C20.865 20.6514 21.2832 20.2687 21.2832 19.7965V16.8896Z",
    stroke: "#052A75",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1582 28.3115H42.32",
    stroke: "#052A75",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0654 33.0801H37.0182",
    stroke: "#052A75",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdea);
export default __webpack_public_path__ + "static/media/idea.a6dac7aa87df54d44ffe3fa1eafe707f.svg";
export { ForwardRef as ReactComponent };